export const evaluateMath = (expr) => {
  // Remove all whitespace
  // eslint-disable-next-line no-param-reassign
  expr = expr.replace(/\s+/g, '');

  // Basic validation
  if (/[^0-9+\-*/().]/.test(expr)) return NaN;

  let pos = 0;

  const parseNumber = () => {
    let start = pos;
    while (pos < expr.length && /[0-9.]/.test(expr[pos])) pos++;
    if (start === pos) throw new Error('Expected number');
    return parseFloat(expr.slice(start, pos));
  };

  const parseFactor = () => {
    if (expr[pos] === '+') { pos++; return parseFactor(); }
    if (expr[pos] === '-') { pos++; return -parseFactor(); }
    if (expr[pos] === '(') {
      pos++;
      let val = parseExpression();
      if (expr[pos] !== ')') throw new Error('Expected )');
      pos++;
      return val;
    }
    return parseNumber();
  };

  const parseTerm = () => {
    let val = parseFactor();
    while (pos < expr.length) {
      let op = expr[pos];
      if (op !== '*' && op !== '/') break;
      pos++;
      let next = parseFactor();
      if (op === '*') val *= next;
      else val /= next;
    }
    return val;
  };

  const parseExpression = () => {
    let val = parseTerm();
    while (pos < expr.length) {
      let op = expr[pos];
      if (op !== '+' && op !== '-') break;
      pos++;
      let next = parseTerm();
      if (op === '+') val += next;
      else val -= next;
    }
    return val;
  };

  try {
    let result = parseExpression();
    if (pos < expr.length) throw new Error('Unexpected character');
    return result;
  } catch (e) {
    return NaN;
  }
};
